import M from "moment";
import React, {Component, Fragment} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import {inputConfig} from "../config/config";
import InventoryInputs from "./inventoryInputs";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {mapToObjectDDL} from "../../../../common/mapper";
import * as R from "ramda";
import {constructDataDetailUnitKSU, constructGenSeqPayload, validateDataDetailUnitKSU} from "../util";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class InventoryCreateUpdate extends Component {
    constructor(props) {
        super(props);
        this.contentConfig = props.contentConfig;
        this.inputConfig = inputConfig[props.tab];
        this.currentDate = M(new Date()).format("DD-MM-YYYY");
        this.tableColumns = [
            {
                name: "id",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return <>{tableMeta.rowIndex + 1}</>;
                    },
                },
            },
            {
                name: this.contentConfig.codeName,
                label: this.contentConfig.codeLabel,
                options: {
                    customBodyRender: (value, {rowIndex, rowData}) => {
                        const isSaved = rowData[rowData.length - 1];
                        const tempLabel = value?.label?.split('-') || []
                        return isSaved
                            ? <p>{tempLabel[0]}</p>
                            : <SimpleDDL
                                id={`select_options_kode_hadiah_${rowIndex}`}
                                containerclassname="margin-bottom-none width width-250px"
                                box={"search"}
                                menuPosition="fixed"
                                options={this.state.dataKSU.map(item => mapToObjectDDL(`${item.kodeKSU} - ${item.name}`, item.kodeKSU))}
                                readOnly={isSaved}
                                isClearable={true}
                                value={value}
                                onChange={(value) =>
                                    this.handleSelectCodeKSU(rowIndex, "kodeKSU", value)
                                }
                            />
                    },
                    sort: false,
                },
            },
            {
                name: "namaKSU",
                label: this.contentConfig.itemLabel,
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "kategori",
                label: "Kategori",
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "jumlah",
                label: "Jumlah*",
                options: {
                    customBodyRender: (val, {rowIndex, rowData, columnData}) => {
                        const isSaved = rowData[rowData.length - 1];
                        return isSaved
                            ? <p>{val}</p>
                            : <SimpleInput
                                value={val}
                                containerclassname="margin-bottom-none width width-100px"
                                readOnly={isSaved}
                                box="onlyNumber"
                                onChange={(e) =>
                                    this.handleValueChange(
                                        rowIndex,
                                        columnData.name,
                                        e.target.value
                                    )
                                }
                            />
                    },
                    sort: false,
                },
            },
            {
                name: "kodeLocation",
                label: "[*] All Locator",
                options: {
                    customHeadRender: (props) => {
                        return (
                            <th className="custom-locator">
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <p>{props.label}</p>
                                    <SimpleDDL
                                        id="select_options_header_locator"
                                        containerclassname="margin-bottom-none width width-250px"
                                        box="search"
                                        isClearable={true}
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                position: "relative",
                                                fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                            }),
                                        }}
                                        options={this.state.dataLocator ? this.state.dataLocator.map(
                                            item => mapToObjectDDL(
                                                item.nameLocation,
                                                item.kodeLocation
                                            )) : []}
                                        onChange={this.handleMultipleLocatorChange}
                                    />
                                </FlexView>
                            </th>
                        );
                    },
                    customBodyRender: (val, {rowIndex, rowData}) => {
                        const isSaved = rowData[rowData.length - 1];
                        return isSaved
                            ? <p>{val?.label}</p>
                            : <SimpleDDL
                                id={`select_options_locator_${rowIndex}`}
                                containerclassname="margin-bottom-none width width-250px"
                                box="search"
                                value={val}
                                menuPosition="fixed"
                                options={this.state.dataLocator ? this.state.dataLocator.map(
                                    item => mapToObjectDDL(
                                        item.nameLocation,
                                        item.kodeLocation
                                    )) : []}
                                readOnly={isSaved}
                                isClearable={true}
                                onChange={(value) =>
                                    this.handleSingleLocatorChange(rowIndex, value)
                                }
                            />
                    },
                    sort: false,
                },
            },
            {
                name: "saved",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => (
                        <FlexView style={{gap: "10px"}}>
                            {
                                !val ?
                                    <SimpleButton
                                        className={"btn background-red"}
                                        styles={{width: "unset", marginLeft: "0px"}}
                                        onClick={() => this.handleSaveRow(rowIndex)}
                                        icon={<i className="fa fa-save"/>}
                                    />
                                    :
                                    <SimpleButton
                                        className={"btn background-red"}
                                        styles={{width: "unset", marginLeft: "0px"}}
                                        onClick={() => this.handleEditRow(rowIndex)}
                                        icon={<i className="fa fa-lw fa-pencil-alt"/>}
                                    />
                            }
                            <SimpleButton
                                className={"btn background-red"}
                                styles={{width: "unset", marginLeft: "0px"}}
                                onClick={() => this.handleDeleteRow(rowIndex)}
                                icon={<i className="fa fa-trash"></i>}
                            />
                        </FlexView>
                    ),
                    sort: false,
                },
            },
        ];
        this.initialData = {
            kodeKSU: null,
            namaKSU: null,
            kategori: null,
            jumlah: null,
            kodeLocation: null,
            qrCode: null,
            numbersOfPrint: null,
            saved: false,
        };
        this.state = {
            [this.contentConfig.codeName]: null,
            warningModalVisible: false,
            dataTable: [],
            dataDetailSaved: [],
            dataSupplier: [],
            dataSupplierExpedition: [],
            dataKSU: [],
            dataLocator: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.fetchDataSupplier();
        this.fetchDataSupplierExpedition();
        let kodeCabang = this.props.selectedCabang;
        let spbkNo = await this.fetchDataGenerateSeq(constructGenSeqPayload(kodeCabang));
        this.props.setValue("spbkNo", !R.isNil(spbkNo) ? spbkNo : null)
        this.props.setValue("kodeCabang", kodeCabang)
        this.handleTriggerLoading();
    }

    handleWarningModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleAddRow = async () => {
        try {
            if (R.isEmpty(this.state.dataKSU)) {
                this.handleTriggerLoading();
                await this.fetchDataKSU();
                await this.fetchDataLocator();
                this.handleTriggerLoading();
            }

            const newUnit = {
                ...this.initialData,
                id: this.state.dataTable.length + 1,
            };

            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: [...prevValue.dataTable, newUnit],
                dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
            }));
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    handleEditRow = async (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleSaveRow = (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
                dataDetailSaved: newState,
            };
        });
    };

    handleDeleteRow = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
            dataDetailSaved: [...prevValue.dataDetailSaved.filter((_, idx) => idx !== index)],
        }));
    };

    handleSelectCodeKSU = async (index, name, value) => {
        if (!R.isEmpty(this.state.dataKSU)) {
            let ksu = this.state.dataKSU.find(item => item.kodeKSU === value?.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaKSU: ksu?.name,
                    kategori: ksu?.categoryDTO?.value,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });
        }
    };

    handleValueChange = (index, colName, value) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable];
            newState[index] = {
                ...newState[index],
                [colName]: value,
            };
            return {
                ...prevState,
                dataTable: newState,
            };
        });
    };

    handleSingleLocatorChange = (index, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                kodeLocation: value,
            };
            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleMultipleLocatorChange = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataTable.map((row) => {
                if (!row.saved) {
                    return {
                        ...row,
                        kodeLocation: value,
                    };
                }
                return row;
            })
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleClearForm = () => {
        this.props.resetIgnoreKeys(["spbkNo", "kodeCabang"]);
        this.props.setValue("spbkDate", this.currentDate);
        this.setState((prevState) => ({
            ...prevState,
            dataTable: [],
        }));
    };

    handleSubmit = () => {
        if (!this.props.validate() || !validateDataDetailUnitKSU(this.state.dataDetailSaved)) {
            this.handleWarningModalVisibility();
        } else {
            let details = constructDataDetailUnitKSU(this.state.dataDetailSaved);
            this.props.onSubmit("save", this.props.controls, details)
        }
    }

    fetchDataSupplier = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierMainDealer,
            menuName: "Receiving Unit - DGI",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplier: res.data.data,
            }));
        }
    }

    fetchDataSupplierExpedition = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
            menuName: "Receiving Unit - DGI",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplierExpedition: res.data.data,
            }));
        }
    }

    fetchDataKSU = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllKSUPagingByParam({
                paramFilters: {}, limit: null, page: null
            });
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataKSU: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

     handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Tambah Penerimaan KSU"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <InventoryInputs
                                {...this.props}
                                dataSupplier={this.state.dataSupplier}
                                dataSupplierExpedition={this.state.dataSupplierExpedition}
                                inputConfig={this.inputConfig}
                            />
                            <FlexView vAlignContent="center" className="margin-bottom-10px">
                                <h4 className="margin-right-10px">UNIT KSU</h4>
                                <SimpleButton
                                    className={"btn btn-plus background-red margin-left-10px"}
                                    onClick={this.handleAddRow}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah KSU"}
                                />
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.dataTable.length}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.tableColumns}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <br/>
                            <FlexView hAlignContent="right">
                                <SimpleButton
                                    type="button"
                                    text="Clear"
                                    // secondary
                                    onClick={() => this.handleClearForm()}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Simpan"
                                    // secondary
                                    onClick={this.handleSubmit}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.props.onClickClose()}
                                />
                            </FlexView>
                        </ModalContainer>
                    }
                />

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
                                </p>
                                <br/>
                                <p>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleWarningModalVisibility()}
                            />
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default withFormGroup(InventoryCreateUpdate);
